import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import NewTermsAndConditions from './components/new-terms-and-conditions';
import NewDisclaimer from './components/new-disclaimer';
import NewPrivacyPolicy from './components/new-privacy-policy';
import Headers from './components/Header';
import CollapseHeaders from './components/collapse-header';
import ThankYou from './components/ThankYou';
import ContactUs from './components/contact-us';
import Errorpage from './components/errorpage';

const MainRoutes = () => {
    return (
        <Routes>
            <Route path="" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/privacypolicy" element={<NewPrivacyPolicy />} />
            <Route
                path="/termsandconditions"
                element={<NewTermsAndConditions />}
            />
            <Route path="/disclaimer" element={<NewDisclaimer />} />
            <Route path="/Hearder" element={<CollapseHeaders />} />
            <Route path="/Thankyou" element={<ThankYou />} />
            <Route path="/enquiry" element={<ContactUs />} />            
            <Route path="*" element={<Errorpage />} />            
        </Routes>
    );
};

export default MainRoutes;
